"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionAction = exports.DEFAULT_REALTIME_SLOT_NAME_WITH_WALRUS = exports.ServiceNames = void 0;
var ServiceNames;
(function (ServiceNames) {
    ServiceNames["AdminApi"] = "adminapi";
    ServiceNames["ApiGateway"] = "api-gateway";
    ServiceNames["Functions"] = "functions";
    ServiceNames["Gotrue"] = "gotrue";
    ServiceNames["Kong"] = "kong";
    ServiceNames["Pgbouncer"] = "pgbouncer";
    ServiceNames["Pgsodium"] = "pgsodium";
    ServiceNames["Postgresql"] = "postgresql";
    ServiceNames["Postgrest"] = "postgrest";
    ServiceNames["Realtime"] = "realtime";
    ServiceNames["Storage"] = "storage";
})(ServiceNames = exports.ServiceNames || (exports.ServiceNames = {}));
exports.DEFAULT_REALTIME_SLOT_NAME_WITH_WALRUS = 'realtime_rls';
var PermissionAction;
(function (PermissionAction) {
    PermissionAction["ANALYTICS_READ"] = "analytics:Read";
    PermissionAction["AUTH_EXECUTE"] = "auth:Execute";
    PermissionAction["BILLING_READ"] = "billing:Read";
    PermissionAction["BILLING_WRITE"] = "billing:Write";
    PermissionAction["CREATE"] = "write:Create";
    PermissionAction["DELETE"] = "write:Delete";
    PermissionAction["FUNCTIONS_READ"] = "functions:Read";
    PermissionAction["FUNCTIONS_WRITE"] = "functions:Write";
    PermissionAction["INFRA_EXECUTE"] = "infra:Execute";
    PermissionAction["READ"] = "read:Read";
    PermissionAction["SQL_SELECT"] = "sql:Read:Select";
    PermissionAction["SQL_DELETE"] = "sql:Write:Delete";
    PermissionAction["SQL_INSERT"] = "sql:Write:Insert";
    PermissionAction["SQL_UPDATE"] = "sql:Write:Update";
    PermissionAction["STORAGE_ADMIN_READ"] = "storage:Admin:Read";
    PermissionAction["STORAGE_ADMIN_WRITE"] = "storage:Admin:Write";
    PermissionAction["TENANT_SQL_ADMIN_READ"] = "tenant:Sql:Admin:Read";
    PermissionAction["TENANT_SQL_ADMIN_WRITE"] = "tenant:Sql:Admin:Write";
    PermissionAction["TENANT_SQL_CREATE_TABLE"] = "tenant:Sql:CreateTable";
    PermissionAction["TENANT_SQL_DELETE"] = "tenant:Sql:Write:Delete";
    PermissionAction["TENANT_SQL_INSERT"] = "tenant:Sql:Write:Insert";
    PermissionAction["TENANT_SQL_QUERY"] = "tenant:Sql:Query";
    PermissionAction["TENANT_SQL_SELECT"] = "tenant:Sql:Read:Select";
    PermissionAction["TENANT_SQL_UPDATE"] = "tenant:Sql:Write:Update";
    PermissionAction["UPDATE"] = "write:Update";
})(PermissionAction = exports.PermissionAction || (exports.PermissionAction = {}));
